export const ALPHABET = 'abcdefghijklmnopqrstuvwxyz'
